import React from 'react';
import { Box, Paper } from '@mui/material';
import { useKBTheme } from '../hooks/useKBTheme';

interface InteractiveDemoProps {
  children: React.ReactNode;
  title?: string;
}

export const InteractiveDemo: React.FC<InteractiveDemoProps> = ({ children, title }) => {
  const { mode } = useKBTheme();

  return (
    <Paper
      elevation={12}
      sx={{
        borderRadius: 4,
        overflow: 'hidden',
        background: mode === 'dark'
          ? 'rgba(15, 23, 42, 0.98)'
          : 'rgba(255, 255, 255, 0.98)',
        border: mode === 'dark'
          ? '1px solid rgba(71, 85, 105, 0.4)'
          : '1px solid rgba(226, 232, 240, 0.8)',
        boxShadow: mode === 'dark'
          ? '0 20px 60px rgba(0, 0, 0, 0.4)'
          : '0 20px 60px rgba(15, 23, 42, 0.15)',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {title && (
        <Box
          sx={{
            p: 2.5,
            borderBottom: mode === 'dark'
              ? '1px solid rgba(71, 85, 105, 0.4)'
              : '1px solid rgba(226, 232, 240, 0.8)',
            background: mode === 'dark'
              ? 'rgba(99,102,241,0.1)'
              : 'rgba(99,102,241,0.05)',
          }}
        >
          <Box
            sx={{
              fontSize: '0.875rem',
              fontWeight: 600,
              color: mode === 'dark' ? '#fff' : '#0f172a',
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
            }}
          >
            {title}
          </Box>
        </Box>
      )}
      <Box sx={{ flex: 1, p: 3, overflow: 'auto' }}>
        {children}
      </Box>
    </Paper>
  );
};








